module.exports = __webpack_public_path__ + "img/customization-options.e4f2c0eb.svg";